export const NOTEBOOK = {
  SECTION: {
    CONTEXT: "CONTEXT",
    TECHNIQUES: "TECHNIQUES",
    DESIGN: "DESIGN",
    PROTOCOL: "PROTOCOL",
    PROBLEM_SOLVING: "PROBLEM_SOLVING",
    RESULTS: "RESULTS",
    REFLECTION: "REFLECTION",
    TROUBLESHOOTING: "TROUBLESHOOTING",
    PROJECT_PLAN: "PROJECT PLAN",
  },
};

export const DESIGN = {
  VIEW: {
    ONE: "DESIGN_VIEW_ONE",
    TWO: "DESIGN_VIEW_TWO",
    THREE: "DESIGN_VIEW_THREE",
    FOUR: "DESIGN_VIEW_FOUR",
  },
  GROUP: {
    A: "GROUP_A",
    B: "GROUP_B",
    C: "GROUP_C",
    D: "GROUP_D",
    E: "GROUP_E",
  },
  NODE: {
    START: "START_NODE",
    END: "END_NODE",
    JOINT: "JOINT_NODE",
    BOX: "BOX_NODE",
    TITLE: "TITLE_NODE",
  },
};

export const DRAG_DROP_DATA = "DRAG_DROP_DATA";
export const DRAG_DROP__ID = "DRAG_DROP__ID";
export const DRAG_DROP__TYPE = "DRAG_DROP__TYPE";

export const DESIGN_SLIDE_TYPES = {
  ONE: "DESIGN_SLIDE_ONE",
  TWO: "DESIGN_SLIDE_TWO",
  THREE: "DESIGN_SLIDE_THREE",
};

export const DESIGN_GROUP = {
  A: "GROUP_A",
  B: "GROUP_B",
  C: "GROUP_C",
  D: "GROUP_D",
  E: "GROUP_E",
};

export const DESIGN_NODE_TYPE = {
  START_NODE: "START_NODE",
  END_NODE: "END_NODE",
  JOINT_NODE: "JOINT_NODE",
  BOX_NODE: "BOX_NODE",
  TITLE_NODE: "TITLE_NODE",
};

export const DESIGN_NODE_COMPONENT_TYPE = {
  HEXAGON_NODE: "HEXAGON_NODE",
};

export const SLIDE_GROUP = {
  JOINT_GROUP: "JOINT_GROUP",
  BOX_GROUP: "BOX_GROUP",
  JOINT_GROUP_SEQUENCE: "JOINT_GROUP_SEQUENCE",
  LABEL_BOX_GROUP: "LABEL_BOX_GROUP",
};

export const SLIDE_NODE = {
  START_NODE: "START_NODE",
  BOX_DRAG_DROP: "BOX_DRAG_DROP",
  JOINT_DRAG_DROP: "JOINT_DRAG_DROP",
  JOINT_PATH_SELECT: "JOINT_PATH_SELECT",
  END_NODE: "END_NODE",
};

export const COMPONENT_TYPE = {
  BODY_TEXT: "BODY_TEXT",
  HEADING: "HEADING",
  COLLAPSIBLE: "COLLAPSIBLE",
  COLLAPSIBLE_NEW: "COLLAPSIBLE_NEW",
  OUTCOME_CARD: "OUTCOME_CARD",
  SLIDE_THREE_OPTION: "SLIDE_THREE_OPTION",
  SLIDE_ONE_OPTION: "SLIDE_ONE_OPTION",
  PLAIN_TEXT: "PLAIN_TEXT",
  ACTIVITY: "ACTIVITY",
  CONDITIONAL_DISPLAY: "CONDITIONAL_DISPLAY",
  NOTEBOOK_IMAGE: "NOTEBOOK_IMAGE",
  SLIDER_IMAGE: "SLIDER_IMAGE",
  SLIDER_WIDGET: "SLIDER_WIDGET",
  CSCQ: "CSCQ",
  CSCQ_NEW: "CSCQ_NEW",
  MSCQ: "MSCQ",
  MSCQ_NEW: "MSCQ_NEW",
  PLOT_CSCQ: "PLOT_CSCQ",
  PLOT: "PLOT",
  SANDBOX_PLOTS: "SANDBOX_PLOTS",
  DDQ: "DDQ",
  OEQ: "OEQ",
  OEQ_DISPLAY: "OEQ_DISPLAY",
  OEQ_NEW: "OEQ_NEW",
  DNDQ_COLOR: "DNDQ_COLOR",
  GROUPED_DNDQ: "GROUPED_DNDQ",
  CSCQ_COLOR: "CSCQ_COLOR",
  MSCQ_DDQ: "MSCQ_DDQ",
  SEQUENCE_SLIDER: "SEQUENCE_SLIDER",
  SEQUENCE_SLIDER_GROUP: "SEQUENCE_SLIDER_GROUP",
  LABEL: "LABEL",
  QUESTION_TABLE: "QUESTION_TABLE",
  DATA_TABLE: "DATA_TABLE",
  TECHNIQUE_CARD: "TECHNIQUE_CARD",
  SUMMARY_TEXT: "SUMMARY_TEXT",
  TAKEAWAY_MESSAGES: "TAKEAWAY_MESSAGES",
  MATERIAL_SECTION: "MATERIAL_SECTION",
  BLOTTING_PAPER: "BLOTTING_PAPER",
  IMAGE_TABLE: "IMAGE_TABLE",
  TEXT_AREA: "TEXT_AREA",
  CONTEXT_TABLE: "CONTEXT_TABLE",
  GEL_COMPONENT: "GEL_COMPONENT",
  RESTRICTION_DIGEST_PREDICTIONS: "RESTRICTION_DIGEST_PREDICTIONS",
  RESTRICTION_DIGEST_RESULTS: "RESTRICTION_DIGEST_RESULTS",
  TABLE_QUESTION: "TABLE_QUESTION",
  TRANSFORMING_BACTERIA_PREDICTIONS: "TRANSFORMING_BACTERIA_PREDICTIONS",
  TRANSFORMING_BACTERIA_RESULTS: "TRANSFORMING_BACTERIA_RESULTS",
  TRANSFORMING_BACTERIA_IDEAL: "TRANSFORMING_BACTERIA_IDEAL",
  LIGATING_DNA_PREDICTIONS: "LIGATING_DNA_PREDICTIONS",
  LIGATING_DNA_RESULTS: "LIGATING_DNA_RESULTS",
  DNA_CLEAVAGE_ASSAY_PREDICTIONS: "DNA_CLEAVAGE_ASSAY_PREDICTIONS",
  DNA_CLEAVAGE_ASSAY_EXPERIMENTAL_DESIGN:
    "DNA_CLEAVAGE_ASSAY_EXPERIMENTAL_DESIGN",
  DNA_CLEAVAGE_ASSAY_RESULTS: "DNA_CLEAVAGE_ASSAY_RESULTS",
  DNA_CLEAVAGE_ASSAY_GEL_RESULTS: "DNA_CLEAVAGE_ASSAY_GEL_RESULTS",
  QUESTION_RESULT: "QUESTION_RESULT",
  RECOMBINANT_PLASMID_PREDICTIONS: "RECOMBINANT_PLASMID_PREDICTIONS",
  RECOMBINANT_PLASMID_RESULTS: "RECOMBINANT_PLASMID_RESULTS",
  PLATING_TRANSFORMED_BACTERIA_PREDICTIONS:
    "PLATING_TRANSFORMED_BACTERIA_PREDICTIONS",
  PREDICTION_QUESTIONS_59: "PREDICTION_QUESTIONS_59",
  RESULTS59: "RESULTS59",
  RESULTS_QUESTIONS_59: "RESULTS_QUESTIONS_59",
  PREDICTIONS_CHOICE_QUESTION: "PREDICTIONS_CHOICE_QUESTION",
  PREDICTIONS_510: "PREDICTIONS_510",
  GEL_RESULTS_510: "GEL_RESULTS_510",
  CONTROL_RESULTS_510: "CONTROL_RESULTS_510",
  GEL_PREDICTIONS_512: "GEL_PREDICTIONS_512",
  GEL_RESULTS_512: "GEL_RESULTS_512",
  SEPARATE_PROTEIN_PREDICTIONS: "SEPARATE_PROTEIN_PREDICTIONS",
  SEPARATE_PROTEIN_RESULTS: "SEPARATE_PROTEIN_RESULTS",
  MATCHING_QUESTION: "MATCHING_QUESTION",
  MATCHING_QUESTION_RESULTS: "MATCHING_QUESTION_RESULTS",
  COLOR_PREDICTION: "COLOR_PREDICTION",
  BANNER: "BANNER",
  RESULT_COMPARISON_PHOTOSYNTHESIS: "RESULT_COMPARISON_PHOTOSYNTHESIS",
  RESULT_COMPARISON_IMAGES: "RESULT_COMPARISON_IMAGES",
  RESULT_COMPARISON_CHARTS: "RESULT_COMPARISON_CHARTS",
  FULL_WIDTH_ANIMATION: "FULL_WIDTH_ANIMATION",
  DIALYSIS_CONCENTRATION_TOGGLE: "DIALYSIS_CONCENTRATION_TOGGLE",
  DIALYSIS_SINGLE_SELECT: "DIALYSIS_SINGLE_SELECT",
  DIALYSIS_DRAG_DROP_QUESTION: "DIALYSIS_DRAG_DROP_QUESTION",
  RESULT_COMPARISON_DIALYSIS: "RESULT_COMPARISON_DIALYSIS",
  DATA_TABLE_RANDOMISER: "DATA_TABLE_RANDOMISER",
  EQUATION: "EQUATION",
  MICROPLATE_READOUT1: "MICROPLATE_READOUT1",
  MICROPLATE_READOUT2: "MICROPLATE_READOUT2",
  IMAGE_SELECTION_QUESTION: "IMAGE_SELECTION_QUESTION",
  JIGSAW_QUESTION: "JIGSAW_QUESTION",
  JIGSAW_QUESTION_DISPLAY: "JIGSAW_QUESTION_DISPLAY",
  DIDYOUKNOW: "DID_YOU_KNOW",
  RESULTS_COMPARISON_MICROSCOPE: "RESULTS_COMPARISON_MICROSCOPE",
  SIM_BANNER: "SIM_BANNER",
  FIGURE: "FIGURE",
  SPECIAL_TEXT_BOX: "SPECIAL_TEXT_BOX",
  IMAGE_TEXTBOX_TILE: "IMAGE_TEXTBOX_TILE",
  SPECIAL_HEADING: "SPECIAL_HEADING",
  ANIMATION_PLAYER: "ANIMATION_PLAYER",
  SPLIT_PATH_QUESTION: "SPLIT_PATH_QUESTION",
};

export const NOTEBOOK_SECTIONS = {
  CONTEXT: "CONTEXT",
  MATERIALS: "MATERIALS",
  PREDICTIONS: "PREDICTIONS",
  TECHNIQUES: "TECHNIQUES",
  DESIGN: "DESIGN",
  PROBLEM_SOLVING: "PROBLEM_SOLVING",
  RESULTS: "RESULTS",
  REFLECTION: "REFLECTION",
  TROUBLESHOOTING: "TROUBLESHOOTING",
  PROJECT_PLAN: "PROJECT PLAN",
  SUMMARY: "SUMMARY",
};

export const VISIBILITY = {
  VISIBLE: "visible",
  HIDDEN: "hidden",
};

export const QUESTION_CONTENTS = {
  QUESTION: "question",
  IMAGE: "image",
  FIGCAPTION: "figcaption",
  TEXT: "text",
  TABLE: "table",
  CONTENT_LIST: "contentList",
  OPTIONS: "options",
  ANSWER_STEPS: "answerSteps",
  SLIDER: "slider",
  TYPED_OPTIONS: "typedOptions",
  SLIDER_GROUPS: "sliderGroups",
  CHECKBOXES: "checkboxes",
  HINTS: "hintDetails",
  DATA_TABLE: "dataTable",
  RESPONSE_AREA: "responseArea",
  FEEDBACK: "feedback",
  VIDEO: "video",
  GRID: "grid",
  DIAGRAM: "diagram",
};

export const PROTOCOL_LAB_APPARATUS = {
  TABLE: "TABLE",
  MICROCENTRIFUGE: "MICROCENTRIFUGE",
  TUBE_STAND_XL_SHORT: "TUBE_STAND_XL_SHORT",
  TUBE_STAND_SM_WIDE: "TUBE_STAND_SM_WIDE",
  TUBE: "TUBE",
  ROTOR: "ROTOR",
  GLASS_TUBE: "GLASS_TUBE",
  CUVETTE_RACK_EXTRA_SHORT: "CUVETTE_RACK_EXTRA_SHORT",
  CUVETTE_RACK_SHORT: "CUVETTE_RACK_SHORT",
  CUVETTE_RACK_LONG: "CUVETTE_RACK_LONG",
  TRASH: "TRASH",
  MICROPIPETTE: "MICROPIPETTE",
  MICROPIPETTE_TIP_BOX: "MICROPIPETTE_TIP_BOX",
};

export const MICROPIPETTE_TYPE = {
  P2: "P2",
  P20: "P20",
  P200: "P200",
  P1000: "P1000",
  TIP_S: "T-P2",
  TIP_M: "T-P20/200",
  TIP_L: "T-1000",
};

export const VIEW_TYPE = {
  WEB: "WEB",
  TAB: "TAB",
  MOB: "MOB",
};

export const TOUR_PROPERTIES = {
  NEXT: "next",
  COMPLETE: "complete",
  CLOSE: "close",
  FINISH: "finished",
  SKIP: "skip",
  IS_EXPERIMENTAL_DESIGN_FINISHED: "IS_EXPERIMENTAL_DESIGN_FINISHED",
};
